export let mobile_mask:any = '000-000-0000';
export let tin_mask:any = '00-0000000';
export let zip_mask:any = '0';
export let email_regex:any = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export let float_regex:any = /^\d{1,6}(\.\d{1,2})?$/;
export let URL_regex : string | RegExp = /^((https?:\/\/)?[wW]{3}\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|(https?:\/\/)?(?:[wW]{3}\.|(?:[wW]{3})\.|(?![wW]{3})|(?![wW]{3}))[a-zA-Z0-9]+\.[^\s]{2,}|[wW]{3}\.[a-zA-Z0-9]+\.[^\s]{2,})$/;
// new regex for webiste
// export let website_regex: any = new RegExp("((http|https):\/\/)?(WWW.|www.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)");
export let website_regex : string | RegExp = /^((https?:\/\/)?[wW]{3}\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|(https?:\/\/)?(?:[wW]{3}\.|(?:[wW]{3})\.|(?![wW]{3})|(?![wW]{3}))[a-zA-Z0-9]+\.[^\s]{2,}|[wW]{3}\.[a-zA-Z0-9]+\.[^\s]{2,})$/;
export let number_regex = /^[0-9]*$/;
export let mobile = /^[0-9]{10}$/;
export let Name:any = /^[a-zA-Z]*$/;
export let Name_space:any = /^[a-zA-Z ]*$/;
export let Name_1:any = /^[^*|\":<>[\]{}`\\()';#%!@&$]+$/; // new RegExp('(' + frechExp + ')|(' + germanExp + ')');
export let Name_3:any = /^[^*|\":<>[\]{}`\\()';#%!@&$+^=_/.,~?-]+$/; // new RegExp('(' + frechExp + ')|(' + germanExp + ')');
export let Email:any = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export let Name_2:any = /^(?=.*[A-Za-z]).+$/;
export let SSN = '000000000'
export let phone_mask = '+1-000-000-0000'
export let name = /^[a-zA-Z ]*$/;
export let dob_mask = '00/00/0000'
export let new_mobile_mask:any = '(000) 000-0000';
export let SSN_mask = '000-00-0000'
export let EIN = '00-0000000'
